import React, { useState, useEffect } from "react";
import "../../styles/Community/PostDeleteModal.css";

const PostDeleteModal = ({ postTitle = "", onClose, onConfirm, loading }) => {
  const [input, setInput] = useState("");

  const canDelete = input.trim() === postTitle.trim();

  const handleConfirm = () => {
    if (canDelete) onConfirm?.();
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return (
    <div className="post-delete-overlay" role="dialog" aria-modal="true">
      <div className="post-delete-container" aria-labelledby="post-delete-title">
        <h2 id="post-delete-title" className="post-delete-title">
          정말로 삭제하시겠습니까?
        </h2>
        <p className="post-delete-description">
          <strong>게시글 삭제</strong>를 원하시면{" "}
          <strong>게시글 제목</strong>을 입력해주세요
        </p>

        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && canDelete) {
              e.preventDefault();
              handleConfirm();
            }
          }}
          className="post-delete-input"
          placeholder={postTitle || "게시글 제목"}
          aria-label="게시글 제목 입력"
          disabled={loading}
        />

        <div className="post-delete-button-row">
          <button
            className="post-delete-cancel-button"
            onClick={onClose}
            disabled={loading}
          >
            취소
          </button>
          <button
            className="post-delete-confirm-button"
            onClick={handleConfirm}
            disabled={loading || !canDelete}
          >
            {loading ? "삭제 중..." : "삭제하기"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostDeleteModal;